import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import * as Yup from "yup"

import Breadcrumbs from "components/Common/BreadcrumbTitle"

import { addNotificationTemplate, editNotificationTemplate, getTemplateNotification } from "../../helpers/UAM/notificationTemplate.helper"
import CommonDialog from "components/Common/CommonDialog"
import { SystemConfigurationContext } from "context/systemConfigContext"
// import { useToast } from "ToastStore"

const AddNotificationTemplate = props => {
  const navigate = useNavigate()
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const location = useLocation()
  const pathnameSegments = location.pathname.split("/")
  const lastSegment = pathnameSegments[pathnameSegments.length - 1]

  //meta title
  let formattedLastSegment = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).toLowerCase();
  document.title = `${formattedLastSegment} Template | DMS`
  const {inputMax} = useContext(SystemConfigurationContext)

  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [templateList, setTemplateList] = useState({})
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);

  // const { handleToastData } = useToast();

  useEffect(() => {
    if (lastSegment == "edit" || lastSegment == "view") {
      getTemplateNotification({ templateId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            setTemplateList(responseFromAPI.data)
            const initialContent = responseFromAPI.data.smsBody;
            const blocksFromHTML = convertFromHTML(initialContent);
            const initialEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(blocksFromHTML));
            setEditorState(initialEditorState);
          }
        })
        .catch(error => { })
    }

    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }
  }, [])

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      notificationType: templateList.notificationType || "",
      purpose: templateList.purpose || "",
      notificationContent: templateList.notificationContent || "",
    },
    validationSchema: Yup.object({
      notificationType: Yup.string().required("Please Enter Notification Type"),
      purpose: Yup.string().required("Please Enter Notification Purpose"),
      notificationContent: Yup.string().required("Please Enter Notification Content")
    }),
    onSubmit: values => {
      const message = lastSegment == 'edit' ? 'Are you sure want to update template?' : 'Do you want to save entry?'
      setShowCommonDialog({ isShow: true, message: message })

    },
  })

  const navigateBack = () => {
    const encryptedtemplate = btoa("notification");
    navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`)
  }

  const submiTemplates = () => {
    const { values } = validation
    if (lastSegment == "edit") {
      const updateTemplate = {
        templateId: decodedId,
        notificationType: values.notificationType,
        purpose: values.purpose,
        notificationContent: values.notificationContent
      }

      editNotificationTemplate(updateTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("notification");
            // handleToastData(responseFromAPI.message, "warning")
            navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`);
          }
        })
        .catch(error => {
          console.log(error)
        })
      validation.resetForm()
    } else {
      const newTemplate = {
        notificationType: values.notificationType,
        purpose: values.purpose,
        notificationContent: values.notificationContent
      }

      addNotificationTemplate(newTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("notification");
            // handleToastData(responseFromAPI.message, "success")
            navigate(`/${roleName}/email-template?temp=${encryptedtemplate}`);
          }
        })
        .catch(error => {
          console.log(error)
        })
      validation.resetForm()
    }
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      submiTemplates()

    } else {

      setShowCommonDialog({ isShow: false })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={`${lastSegment.toUpperCase()} TEMPLATE`} />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  {showEditTemplate && <form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Type
                        </Label>
                        <Input
                          maxLength={inputMax}
                          type="text"
                          className="form-control"
                          name="notificationType"
                          id="horizontal-notification-Input"
                          placeholder="Enter Notification Type"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.notificationType || ""}
                          invalid={
                            validation.touched.notificationType &&
                              validation.errors.notificationType
                              ? true
                              : false
                          }
                        />
                        {validation.touched.notificationType &&
                          validation.errors.notificationType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.notificationType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Purpose
                        </Label>
                        <Input
                          type="text"
                          maxLength={inputMax}
                          className="form-control"
                          name="purpose"
                          id="horizontal-email-Input"
                          placeholder="Enter Notification Purpose "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.purpose || ""}
                          invalid={
                            validation.touched.purpose &&
                              validation.errors.purpose
                              ? true
                              : false
                          }
                        />
                        {validation.touched.purpose &&
                          validation.errors.purpose ? (
                          <FormFeedback type="invalid">
                            {validation.errors.purpose}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label required"
                        >
                          Notification Content
                        </Label>
                        <Input
                         maxLength={inputMax}
                          type="textarea"
                          className="form-control"
                          name="notificationContent"
                          style={{ height: "200px" }}
                          id="horizontal-sms-Input"
                          placeholder="Enter Notification Content"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.notificationContent || ""}
                          invalid={
                            validation.touched.notificationContent &&
                              validation.errors.notificationContent
                              ? true
                              : false
                          }
                        />
                        {validation.touched.notificationContent &&
                          validation.errors.notificationContent ? (
                          <FormFeedback type="invalid">
                            {validation.errors.notificationContent}
                          </FormFeedback>
                        ) : null}
                      </Col>


                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end" style={{ margin: "20px 0% 0px 0px" }}>
                          <button
                            type="submit"
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack();
                            }
                            }
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                            style={{ marginLeft: "7px" }}
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>}
                  {showViewTemplate && <div>
                    <Row className="mb-4">
                      <Col sm={6}>
                        <Label
                          className="col-sm-3 col-form-label label  label-styling text-secondary "
                        >
                          Type
                        </Label>
                          <p>{templateList.notificationType || "-"}</p>
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label label label-styling text-secondary "
                        >
                          Purpose
                        </Label>
                          <p>{templateList.purpose || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={6}>
                        <Label
                          className="col-sm-6 col-form-label label label-styling text-secondary "
                        >
                          Notification Content
                        </Label>
                          <p>{templateList.notificationContent || "-"}</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="text-end" >
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
    </React.Fragment>
  )
}

AddNotificationTemplate.propTypes = {
  history: PropTypes.object,
}

export default AddNotificationTemplate
